import { renderAs, type IntrinsicTag, type PolymorphicProps } from '@/components/motion/polymorphic'
import { cn } from '@/lib/utils'

interface SkeletonGroupOwnProps {
  className?: string | undefined
}

export type SkeletonGroupProps<T extends IntrinsicTag> = PolymorphicProps<T, SkeletonGroupOwnProps>

/**
 * A loading shape's blocks, held back for 80ms and then faded in together
 * (`animate-skeleton-in`), so a load that lands inside the wait never flashes
 * grey. Renders the element itself (a `div` unless `as` says otherwise), so
 * the blocks keep the layout the markup already gave them.
 *
 * For a block on its own, `<Skeleton appear />`. Not for a card's or a
 * section's loading state, which `CardState` / `QueryState` already time.
 */
export default function SkeletonGroup<T extends IntrinsicTag = 'div'>({
  as,
  className,
  ...rest
}: SkeletonGroupProps<T>) {
  return renderAs(as ?? 'div', { ...rest, className: cn('animate-skeleton-in', className) })
}
